import { $, _, Backbone, Foundation, Radio, moment, Datepicker } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import Notification from "../../utils/Notification";

import NumberDiscountSidebarTpl from "../../templates/pricediscounts/NumberDiscountSidebarTpl.html";

export default InboomaBaseView.extend({
  template: NumberDiscountSidebarTpl,
  el: "#inb-c-sidebar",
  templateContext() {
    return {
      _,
      moment,
    };
  },

  _filterCountNotification: {},
  _collectionEmptyNotification: {},

  ui: {},

  events: {},

  initialize() {
    this.render();
  },
});
